mzAnimator = {
	['heightOrigin']:[],
	animateMain: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');

		fromAnim='';

		if(group.classList.contains('mz-hero-menu')) gsap.set(target,{marginTop: 0});

		toAnim= {alpha:0, top:'-=100px'};
		speed=0.5;
		start='40px top';
		this.createTimeline(target, fromAnim, toAnim, speed, start, true);


		target = group.querySelector('.mz-hero-bottom');
		fromAnim='';
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				toAnim= {alpha:0};
				speed=0.5;
			},
			"(min-width: 768px)": function() {
				toAnim= {bottom:'-100%', alpha:0};
				speed=0.2;
			}
		});
		start='bottom center';
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		if(group.classList.contains('mz-hero-last')){
			this.animateFixed(group);
		}

		this.animateBG(group);
		this.animateFade(group);
	},
	animateMainVideo: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');

		//if(group.classList.contains('mz-hero-menu')) gsap.set(target,{marginTop: 0});
		
		fromAnim='';
		toAnim= {alpha:0, top:'-=100px'};
		speed=0.5;
		start='10px top';
		this.createTimeline(target, fromAnim, toAnim, speed, start, true);

		target = group.querySelector('.mz-hero-bottom');
		fromAnim='';
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				toAnim= {alpha:0};
				speed=0.5;
			},
			"(min-width: 768px)": function() {
				toAnim= {bottom:'-100%', alpha:0};
				speed=0.2;
			}
		});
		start='bottom center';
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		this.animateFade(group);
	},
	scrubImage: function(group){
		const preloadPercent = 0.75;

		const mobileDir = ['xs', 'sm', 'md'].includes(mzFunc.getMediaQuery()) ? true : false;

		console.log(mobileDir);

		const frameCount = Number(group.dataset['frames']);
		const filepath = mobileDir ? group.dataset['mobileFilepath'] : group.dataset['filepath'];
		const filename = mobileDir ? group.dataset['mobileFilename'] : group.dataset['filename'];
		const filetype = mobileDir ? group.dataset['mobileFiletype'] : group.dataset['filetype'];
		const stopAnimation = Number(group.dataset['stopAnimation'])
		const speed = Number(group.dataset['speed']);
		const image = group.querySelector('.mz-video img');
		const canvas = group.querySelector('canvas');
		const context = canvas.getContext("2d");

		screenHeight = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) ? window.screen.height : window.innerHeight;

		const vidHeight = ['xs', 'sm', 'md'].includes(mzFunc.getMediaQuery()) ? 854 :
			['md'].includes(mzFunc.getMediaQuery()) ? 1080 
			: 900;
		const vidWidth = ['xs', 'sm', 'md'].includes(mzFunc.getMediaQuery()) ? 480  :
			['md'].includes(mzFunc.getMediaQuery()) ? 720 
			: 1600;
		
		const vRatio = Math.round((screenHeight / vidHeight) * vidWidth);
		const hRatio = Math.round((document.documentElement.clientWidth / vidWidth) * vidHeight);

		if(hRatio < screenHeight){
			canvas.width = vRatio;
			canvas.height = screenHeight;
			gsap.set(image,{height:screenHeight, width:vRatio});
			gsap.set([image, canvas], {position:'absolute', left: -((vRatio-document.documentElement.clientWidth)/2)});
		}else{
			canvas.width = document.documentElement.clientWidth;
			canvas.height = hRatio;
			gsap.set(image,{height:hRatio, width:document.documentElement.clientWidth});
			gsap.set([image, canvas], {position:'absolute', top: -((hRatio-screenHeight)/2)});
		}
	
		const currentFrame = (index)=>{	
			return filepath + filename + String(index) + filetype;
		};

		const images = []
		const anim = {
			frame: 2
		};
		//load all the images
		for (let i = 1; i <= frameCount; i++) {
			const img = new Image();
			img.src = currentFrame(i);
			images.push(img);
			//enable scrub when % of images are loaded
			if(i=== Math.round(frameCount*preloadPercent)){
				img.addEventListener('load',()=>{
					runScrub();
				})
			}	
		}

		image.setAttribute('src',currentFrame(1));

		function runScrub(){
			gsap.set(group, {height:Math.round(screenHeight*(frameCount/60/speed)+(screenHeight))});

			gsap.to(anim,{
				frame: frameCount-1,
				ease: "none",
				snap: "frame",
				scrollTrigger: {
					trigger: canvas,
					pin:true,
					scrub: true,
					start: "top top",
					end: '+=' + Math.round(screenHeight*(frameCount/60/speed)) + 'px',
					onEnter: ()=>{
						canvas.style.opacity=1;
					},
					onEnterBack: ()=>{
						canvas.style.opacity=1;
					},
					onUpdate: self => {
						context.clearRect(0, 0, canvas.width, canvas.height);
						context.drawImage(images[anim.frame], 0, 0, canvas.width, canvas.height);
					}
				},
			});
		}
	},
	animateCarousel: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');

		fromAnim='';

		if(group.classList.contains('mz-hero-menu')) gsap.set(target,{marginTop: 0});

		toAnim= {alpha:0, top:'-=100px'};
		speed=0.5;
		start='40px top';
		this.createTimeline(target, fromAnim, toAnim, speed, start);


		target = group.querySelector('.mz-hero-bottom');
		fromAnim='';
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				toAnim= {alpha:0};
				speed=0.5;
			},
			"(min-width: 768px)": function() {
				toAnim= {alpha:-5};
				speed=0.2;
			}
		});
		start='bottom center';
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		this.animateFade(group);
	},
	animatePromo: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-logo');
		fromAnim={top:-200};
		fromAnim= {top:'-=100%'};
		toAnim= '';
		speed=1;
		start='top center';
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		target = group.querySelector('.mz-hero-content');
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				fromAnim={top:'+=30%'};
				toAnim= {top:'-=30%'};
				start='top bottom';
				speed=3;
			},
			"(min-width: 768px)": function() {
				fromAnim={autoAlpha:0, top:-200};
				toAnim= {autoAlpha:1, top:0};
				start='-200 top';
				speed=2;
			}
		});
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		if(group.classList.contains('mz-hero-last')){
			this.animateFixed(group);
		}

		this.animateBG(group);
		this.animateFade(group);
	},
	animateOverlay: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');
		if(!target.classList.contains('active')){
			fromAnim={autoAlpha:0};
			toAnim= {autoAlpha:1};
			ScrollTrigger.matchMedia({
				"(max-width: 767px)": function() {
					speed=4;
				},
				"(min-width: 768px)": function() {
					speed=3;
				}
			});

			start='top center';
			this.createTimeline(target, fromAnim, toAnim, speed, start);
		}

		target = group.querySelector('.wysiwyg');
		fromAnim={autoAlpha:0};
		toAnim= {autoAlpha:1};
		start='bottom bottom';
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				speed=3.5;
			},
			"(min-width: 768px)": function() {
				speed=2.5;
			}
		});

		this.createTimeline(target, fromAnim, toAnim, speed, start);

		if(group.classList.contains('mz-hero-last')){
			this.animateFixed(group);
		}

		this.animateBG(group);
		this.animateFade(group);
	},
	animateOverlayVideo: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');
		if(!target.classList.contains('active')){
			fromAnim={autoAlpha:0};
			toAnim= {autoAlpha:1};
			ScrollTrigger.matchMedia({
				"(max-width: 767px)": function() {
					speed=4;
				},
				"(min-width: 768px)": function() {
					speed=3;
				}
			});

			start='top center';
			this.createTimeline(target, fromAnim, toAnim, speed, start);
		}

		target = group.querySelector('.wysiwyg');
		fromAnim={autoAlpha:0};
		toAnim= {autoAlpha:1};
		start='bottom bottom';
		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				speed=3.5;
			},
			"(min-width: 768px)": function() {
				speed=2.5;
			}
		});

		this.createTimeline(target, fromAnim, toAnim, speed, start);

		this.animateFade(group);
	},
	animateSimple: function(group){
		let target, fromAnim, toAnim, speed, start, pin;

		target = group.querySelector('.mz-hero-content');

		ScrollTrigger.matchMedia({
			"(max-width: 767px)": function() {
				speed=2;
				start='center top';
				toAnim= {top: '+=50%'};
				pin= false;
			},
			"(min-width: 768px)": function() {
				speed=0.2;
				start='top top';
				fromAnim={top:'0'};
				toAnim= {top: '-=50%'};
				pin=true;
			}
		});

 		this.createTimeline(target, fromAnim, toAnim, speed, start, pin);

		 if(group.classList.contains('mz-hero-last')){
			this.animateFixed(group);
		}

		this.animateBG(group);
		this.animateFade(group);
	},
	animateSplit:function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-content');
		if(!target.classList.contains('active')){
			fromAnim={autoAlpha:0};
			toAnim= {autoAlpha:1};
			speed=2;
			start='-75% top';
			this.createTimeline(target, fromAnim, toAnim, speed, start);
		}

		target = group.querySelector('.mz-svg-arrow_thin_long');
		fromAnim={autoAlpha:0, x:-60};
		toAnim= '';
		speed=2;
		start='-100px center';
		this.createTimeline(target, fromAnim, toAnim, speed, start);

		target = group.querySelector('.splitText');
		speed=1;
		start='top center';
		end='bottom center';
		splitTextArr = new SplitText(target, {
			type: 'words, chars',
		});

		gsap.timeline({paused: true, scrollTrigger: {
			trigger: mzFunc.getDomPath(target),
			scrub: true,
			start: start,
			end: end
		}}).from(splitTextArr.chars, {transformOrigin: "0% 50% -50",stagger: 0.02, color:'#5f5f5f' });

		if(group.classList.contains('mz-hero-last')){
			this.animateFixed(group);
		}

		this.animateBG(group);
		this.animateFade(group);
	},
	animateFade(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-fadeout');
		fromAnim='';
 		toAnim= {autoAlpha:0.8};
 		speed=3;
 		start='50% top';
 		this.createTimeline(target, fromAnim, toAnim, speed, start);

	},
	animateBG: function(group){
		let target, fromAnim, toAnim, speed, start;

		target = group.querySelector('.mz-hero-inside>.mz-image');
		if(target!=null){
			//target = group.querySelector('.mz-hero-inside>.mz-video');

			fromAnim={top:0, scale:1.05};
			toAnim= {top:'-=5%', scale:1};

	 		speed=1;
	 		start='top top';
	 		this.createTimeline(target, fromAnim, toAnim, speed, start, true);
		}

	},
	animateFixed: function(group){
		const fixedEl = document.querySelector('.mz-hero-fixed');
		const controlEl = document.querySelector(`.mz-video-loop-control--external[data-id="${fixedEl.querySelector('[data-id]')?.dataset['id']}"`);
		const videoEl = fixedEl?.getElementsByTagName('video')[0];
		const pauseEnd = group.classList.contains('mz-hero-menu') ? '120% bottom' : 'top top';

		const showFixed = (isHidden)=>{
			if(isHidden){
				gsap.to(mzFunc.getDomPath(controlEl), 0.3, {autoAlpha:1});

			}else{
				gsap.to(mzFunc.getDomPath(controlEl), 0.3, {autoAlpha:0});
			}
		}
		const showVideo = (isHidden)=>{
			const isPaused = controlEl.classList.contains('active');
			if(videoEl.getAttribute.src !== undefined){
				if(isHidden){
					if(isPaused){
						videoEl.pause();
					}else{
						videoEl.play()
					};
				}else{
					videoEl.pause();
				}
			}
		}
		ScrollTrigger.create({
			trigger: mzFunc.getDomPath(group),
			start: 'top bottom',
			end: pauseEnd,
			scrub: false,
			pin:false,
			onEnter: ()=>{
				showFixed(true);
			},
			onEnterBack:()=>{
				showFixed(true);
			},
			onLeave: ()=>{
				showFixed(false);
			}
		});
		ScrollTrigger.create({
			trigger: group.querySelector('.mz-hero-inside'),
			start: 'top bottom',
			end: 'bottom top',
			scrub: false,
			pin:false,
			onEnter: ()=>{
				showVideo(true);
			},
			onEnterBack:()=>{
				showVideo(true);
			},
			onLeave: ()=>{
				showVideo(false);
			}
		});
		

	},
	animateHeight: function( target, id, opening, isToggled=false){
		if(target && id){
			let time=0;
			let maxTime=1;
			let minTime=0.1;
			if(opening==='init'){
				const currentHeight=target.clientHeight;
				gsap.set(target,{height:'auto'});
				mzAnimator.heightOrigin[id] = target.clientHeight;
				if(target.dataset['isExpanded'] !== 'true' && !isToggled){
					gsap.set(target,{height:0})
				}else{
					gsap.set(target,{height:currentHeight});
					const newTime = mzAnimator.heightOrigin[id] / 500;
					time = maxTime < newTime ? maxTime : newTime < minTime ? minTime : newTime;
					gsap.to(target, time,{height:mzAnimator.heightOrigin[id], ease:'power1.inOut'})
				}
			}else if(opening){
				const newTime = mzAnimator.heightOrigin[id] / 500;
				time = maxTime < newTime ? maxTime : newTime < minTime ? minTime : newTime;
				gsap.to(target, time,{height:mzAnimator.heightOrigin[id], ease:'power1.inOut'})
			}else{
				const newTime = mzAnimator.heightOrigin[id] / 500;
				time = maxTime < newTime ? maxTime : newTime < minTime ? minTime : newTime;
				gsap.to(target, time,{height:0, ease:'power1.inOut'})
			}
		}else{
			mzFunc.logging('Animating height issue', 'target', target, 'id', id)
		}
	},
	animateCars: function(group){
		let fromAnim, toAnim, speed, start;

		const targets = group.querySelectorAll('.mz-vehicle-cta');
		ScrollTrigger.create({
		  trigger: mzFunc.getDomPath(group),
		  start: 'top bottom',
		  scrub: false,
		  pin:false,
		  onEnter: ()=>{
			  targets.forEach( (target,index) =>{
	  			let offset= 0.3 * index;
	  			speed=1.5;
				gsap.set(mzFunc.getDomPath(target), {autoAlpha:0, x:'-80px'})
	  			 gsap.to(mzFunc.getDomPath(target), speed, {delay: offset, autoAlpha:1, x:0});
	  		})
		  }
		});
	},
	createTimeline:function(target, fromAnim, toAnim, speed, start, pin=false){
		if(target){
			let tl = gsap.timeline({defaults:{ease: Linear.easeNone}})

			if(target){
				if(fromAnim != '' && toAnim != ''){
					tl.fromTo( mzFunc.getDomPath(target), fromAnim, toAnim);
				}else if(fromAnim != ''){
					tl.from( mzFunc.getDomPath(target), fromAnim);
				}else if(toAnim != ''){
					tl.to(mzFunc.getDomPath(target), toAnim);
				}
			}
			ScrollTrigger.create({
			  trigger: mzFunc.getDomPath(target),
			  start: start,
			  end: '+=' + Math.round(target.offsetHeight/speed) + 'px',
			  scrub: true,
			  pin:pin,
			  animation: tl
			});
		}
	},
	init: function () {
		const animGroup= document.querySelectorAll('[animation-group]');
		if (animGroup.length > 0) {
			animGroup.forEach(group => {
				switch(group.getAttribute('animation-group')){
					case 'main':
						mzAnimator.animateMain(group);
						break;
					case 'main_video':
						mzAnimator.animateMainVideo(group);
						break;
					case 'scrolling_video':
						mzAnimator.animateScrollingVideo(group);
						break;
					case 'scrub_images':
						mzAnimator.scrubImage(group);
						break;
					case 'overlay':
						mzAnimator.animateOverlay(group);
						break;
					case 'overlay_video':
						mzAnimator.animateOverlay(group);
						break;
					case 'promo':
						mzAnimator.animatePromo(group);
						break;
					case 'simple':
						mzAnimator.animateSimple(group);
						break;
					case 'split':
						mzAnimator.animateSplit(group);
						break;
					case 'cars':
						mzAnimator.animateCars(group);
						break;
					case 'carousel':
						mzAnimator.animateCarousel(group);
						break;
					default:
						break;
				}
			});
		}
	}
};